import { SliderModels } from '@/types/slider'
import PptPageHeatMap from '../PptPageHeatMap/PptPageHeatMap'
import PptPageHeatMapFrame from '../PptPageHeatMapFrame/PptPageHeatMapFrame'
import PptPageEnd from '../PptPageEnd/PptPageEnd'
import { isPortraitByProjectInfo } from '@/helpers/productCategory'

const PORTRAIT_HEATMAPS_PER_PAGE = 14
const DEFAULT_HEATMAPS_PER_PAGE = 12

interface Props {
  project: ProjectModels.ProjectDetail
  onSliderReady: (slider: SliderModels.Slider, no: number) => void
  baseNo: number
}

function HeatMapPptPage(props: Props) {
  const heatMapsPerPage = isPortraitByProjectInfo(props.project) ? PORTRAIT_HEATMAPS_PER_PAGE : DEFAULT_HEATMAPS_PER_PAGE
  const heatMaps = Array.from(
    props.project.detailMetrics.reduce((map, detail) => {
      const second = Number(detail.secondCount)
      if (!Number.isFinite(second) || map.has(second)) {
        return map
      }
      map.set(second, { heatMap: detail.heatMap, second })
      return map
    }, new Map<number, { heatMap: string; second: number }>())
  ).map(([, value]) => value)

  const framePages = heatMaps.reduce(
    (prev: { heatMap: string; second: number }[][], cur) => {
      const last = prev[prev.length - 1]
      if (!last) {
        return [[cur]]
      } else {
        if (last.length < heatMapsPerPage) {
          last.push(cur)
        } else {
          prev.push([cur])
        }
      }
      return prev
    },
    [] as { heatMap: string; second: number }[][]
  )

  return (
    <>
      <PptPageHeatMap
        no={props.baseNo + 1}
        project={props.project}
        onSliderReady={props.onSliderReady}
      />
      {framePages.map((frames, index) => {
        return (
          <PptPageHeatMapFrame
            key={index}
            no={props.baseNo + 2 + index}
            project={props.project}
            heatMaps={frames}
            onSliderReady={props.onSliderReady}
          />
        )
      })}
      <PptPageEnd
        no={props.baseNo + 2 + framePages.length}
        project={props.project}
        onSliderReady={props.onSliderReady}
      />
    </>
  )
}

export default HeatMapPptPage
